export const isSigner = (signerOrProvider) => 'getAddress' in signerOrProvider;
